class Selector {
  items = [];
}

class SelectorItem {
  key = '';
  props = [];
  fakeClass = [];
}

class Expression {
  key = '';
  value = '';
  operator = '';
}

export class Parser {
  cache = {};

  parse(exp) {
    if (this.cache[exp]) {
      return this.cache[exp];
    }
    const selector = new Selector();
    this.cache[exp] = selector;
    let i = 0;
    let selectorItem = new SelectorItem();

    while (i < exp.length) {
      const char = exp[i];

      switch (char) {
        case ' ':
          if (selectorItem.key !== '') {
            selector.items.push(selectorItem);
            selectorItem = new SelectorItem();
          }
          i++;
          break;
        case '[':
          // 解析表达式
          const expression = this.parseExpression(exp, i);
          if (expression) {
            selectorItem.props.push(expression);
            i = expression.endIndex + 1;
          } else {
            i++;
          }
          break;
        case ':':
          // 解析伪类
          const pseudo = this.parsePseudoClass(exp, i);
          if (pseudo) {
            selectorItem.fakeClass.push(pseudo);
            i = pseudo.endIndex + 1;
          } else {
            i++;
          }
          break;
        default:
          // 解析选择器名称
          selectorItem.key += char;
          i++;
      }
    }

    if (selectorItem.key !== '') {
      selector.items.push(selectorItem);
    }

    return selector;
  }

  parseExpression(exp, index) {
    const expression = new Expression();
    const startIndex = index + 1;
    const endIndex = exp.indexOf(']', startIndex);

    if (endIndex === -1) {
      return null; // 缺少闭合括号
    }

    const content = exp.substring(startIndex, endIndex).trim();
    const operatorMatch = content.match(/(\*=|~=|\|=|\^=|\$=|=)/); // 匹配操作符
    const operator = operatorMatch ? operatorMatch[1] : '='; // 提取操作符，默认为等号

    const parts = content.split(operator); // 使用匹配到的操作符分割 key 和 value
    if (parts.length === 2) {
      expression.key = parts[0].trim();
      expression.value = parts[1].trim().replace(/^["']|["']$/g, ''); // 移除值周围的引号
      expression.operator = operator;
    } else {
      expression.key = content.trim(); // 只有 key
      expression.operator = '='; // 默认操作符为等号
    }

    expression.endIndex = endIndex;
    return expression;
  }

  parsePseudoClass(exp, index) {
    const startIndex = index + 1;
    let endIndex = exp.indexOf(' ', startIndex); // 假设到空格结束

    if (endIndex === -1) {
      endIndex = exp.length;
    }

    const pseudoClass = exp.substring(startIndex, endIndex).trim();
    return {
      name: pseudoClass,
      endIndex: endIndex - 1,
    };
  }
}
